import { toaster } from '@/components/ui/toast'
import { createMutation } from '@tanstack/solid-query'
import { createSignal } from 'solid-js'
import { whenDeleting } from '../Messages/whenDeleting'

export function useDelete() {
  const [deletingId, setDeletingId] = createSignal<string | null>(null)

  const deleteMutation = createMutation(() => ({
    mutationFn: (id: string) => whenDeleting(id),
    onSuccess: () => setDeletingId(null),
    onError: (error: any) => {
      toaster.create({
        title: 'Error Deleting Message',
        description: error.message || 'There was an error deleting the message. Please try again.',
        type: 'error',
      })
    }
  }))

  return {
    deleteMutation,
    deletingId,
    setDeletingId,
  }
}
